export const INSURANCE_REPORT_LOADING_STORAGE_KEY = 'insuranceReportGenerationStatus';
export const AI_REPORT_DISCLAIMER_KEY = 'isAgreeWithAIReportDisclaimer';

export const canUseBrowserStorage = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const readJsonFromStorage = (key, fallbackValue) => {
    if (!canUseBrowserStorage()) return fallbackValue;
    try {
        const rawValue = window.localStorage.getItem(key);
        if (!rawValue) return fallbackValue;
        const parsedValue = JSON.parse(rawValue);
        return parsedValue ?? fallbackValue;
    } catch (error) {
        return fallbackValue;
    }
};

export const writeJsonToStorage = (key, value) => {
    if (!canUseBrowserStorage()) return;
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        // Ignore storage write failures (quota exceeded, private mode, etc.)
    }
};

export const getPersistedReportLoadingMap = () => {
    const stored = readJsonFromStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, {});
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
        writeJsonToStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, {});
        return {};
    }
    return stored;
};

export const getAiReportDisclaimerAgreements = () => {
    const stored = readJsonFromStorage(AI_REPORT_DISCLAIMER_KEY, []);
    if (!Array.isArray(stored)) {
        writeJsonToStorage(AI_REPORT_DISCLAIMER_KEY, []);
        return [];
    }
    return stored;
};
